<div class="bgfull">
        <div class="bgRelated">
            <div class="container">
                <div class="content">
                    <h2 class="titleModal text-center col-12 float-left text-uppercase branded04">
                            RELATED SOLUTIONS
                    </h2>
                    <ul>
                        <li>
                            <a href="#">
                                <img src="http://gsctool-web.actionlabs.com.br/london.61495775ce3261904e6f.jpg" />
                                <div>
                                    <h3 class="titleRelated branded01">Título contendo 66 caracteres lorem ipsum dolor sit amet consectes</h3>
                                    <span class="catRelated grey01">Fornecedor XPTO</span>
                                    <p class="parRelated dark03">Resumo com 120 caracteres lorem ipsum dolor sit amet, consectetur adipiscing elit nam ex dolor, consequat at mattis sita</p>
                                </div>
                            </a>
                        </li>
                        <li>
                            <a href="#">
                                <img src="http://gsctool-web.actionlabs.com.br/madrid.f2da70842e0bacaf3b7b.jpg" />
                                <div>
                                    <h3 class="titleRelated branded01">Título contendo 66 caracteres lorem ipsum dolor sit amet consectes</h3>
                                    <span class="catRelated grey01">Fornecedor XPTO</span>
                                    <p class="parRelated dark03">Resumo com 120 caracteres lorem ipsum dolor sit amet, consectetur adipiscing elit nam ex dolor, consequat at mattis sita</p>
                                </div>
                            </a>
                        </li>
                        <li>
                            <a href="#">
                                <img src="http://gsctool-web.actionlabs.com.br/tokyo.856552caa7adea322f11.jpg" />
                                <div>
                                    <h3 class="titleRelated branded01">Título contendo 66 caracteres lorem ipsum dolor sit amet consectes</h3>
                                    <span class="catRelated grey01">Fornecedor XPTO</span>
                                    <p class="parRelated dark03">Resumo com 120 caracteres lorem ipsum dolor sit amet, consectetur adipiscing elit nam ex dolor, consequat at mattis sita</p>
                                </div>
                            </a>
                        </li>
                        <li>
                            <a href="#">
                                <img src="http://gsctool-web.actionlabs.com.br/madrid.f2da70842e0bacaf3b7b.jpg" />
                                <div>
                                    <h3 class="titleRelated branded01">Título contendo 66 caracteres lorem ipsum dolor sit amet consectes</h3>
                                    <span class="catRelated grey01">Fornecedor XPTO</span>
                                    <p class="parRelated dark03">Resumo com 120 caracteres lorem ipsum dolor sit amet, consectetur adipiscing elit nam ex dolor, consequat at mattis sita</p>
                                </div>
                            </a>
                        </li>
                    </ul>
                    <div class="col-lg-12 formInput float-left">
                        <a href="#" class="btnBranded btnBrandedForm" >SEE ALL SOLUTIONS</a>
                    </div>
                </div>
            </div>
        </div>
</div>